const t = {
  name: "Edit2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.1213 2.70705C18.9497 1.53548 17.0503 1.53547 15.8787 2.70705L7 11.5857V16.9999H12.4142L21.2929 8.12126C22.4645 6.94969 22.4645 5.0502 21.2929 3.87862L20.1213 2.70705ZM17.2929 4.12126C17.6834 3.73074 18.3166 3.73074 18.7071 4.12126L19.8787 5.29284C20.2692 5.68336 20.2692 6.31652 19.8787 6.70705L11.5858 14.9999H9V12.4142L17.2929 4.12126Z" fill="currentColor"/>
<path d="M5 1.99994C3.34315 1.99994 2 3.34308 2 4.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H19C20.6569 21.9999 22 20.6568 22 18.9999V13.9999H20V18.9999C20 19.5522 19.5523 19.9999 19 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V4.99994C4 4.44765 4.44772 3.99994 5 3.99994H10V1.99994H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Edit2
};
